import { Table } from 'antd';
import classNames from 'classnames';
import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri';
import type { PaginationProps, TableProps } from 'antd';
import type { AnyObject } from 'antd/es/_util/type';
import { IoMdArrowDown, IoMdArrowUp } from 'react-icons/io';

export type StyleTableProps<RecordType> = TableProps<RecordType> & {
    fill?: boolean;
};

export function StyledTable<RecordType extends object = AnyObject>({
    pagination,
    scroll,
    fill = false,
    ...props
}: StyleTableProps<RecordType>) {
    const tableClasses = classNames('styled-table', props.className, {
        'ant-table-has-pagination': pagination !== false,
    });

    const paginationRender: PaginationProps['itemRender'] = (_page, type, originalElement) => {
        if (type === 'prev') {
            return (
                <button className="ant-pagination-item-link" type="button" tabIndex={-1}>
                    <RiArrowLeftSLine size={22} className="prev-icon" />
                </button>
            );
        } else if (type === 'next') {
            return (
                <button className="ant-pagination-item-link" type="button" tabIndex={-1}>
                    <RiArrowRightSLine size={22} className="next-icon" />
                </button>
            );
        }
        return originalElement;
    };

    const columns =
        props?.columns?.map((column) => ({
            ...column,
            sortIcon: ({ sortOrder }: { sortOrder: 'ascend' | 'descend' | null }) => {
                if (!sortOrder) {
                    return null;
                }

                const SortIcon = sortOrder === 'descend' ? IoMdArrowDown : IoMdArrowUp;
                return <SortIcon color="#1677FF" style={{ marginLeft: 10 }} />;
            },
        })) || [];

    return (
        <Table
            className={tableClasses}
            pagination={
                pagination === false
                    ? false
                    : {
                          itemRender: paginationRender,
                          showSizeChanger: false,
                          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                          ...pagination,
                      }
            }
            scroll={{
                y: fill ? `calc(100% - 55px)` : undefined,
                x: 'max-content',
                ...scroll,
            }}
            {...props}
            columns={columns}
            data-testid="styled-table"
        />
    );
}
